module.exports = __webpack_public_path__ + "static/img/image_bg1.73940f8e.jpg";